export default "__VITE_ASSET__278d3afd__"